<template>
	<div class="page-content">
		<!-- Navigation Strip -->
		<div class="strip fs-14 between-flex">
			<div class="left-strip">
				<a 
					class="menu-item"
					href="#"
					:class="{ active: currentSection === 'myPackages' }"
					@click.prevent="currentSection = 'myPackages'"
				>
					<span class="material-symbols-outlined">home_repair_service</span>
					{{ $t('Package.myPackages') }}
				</a>
				<a 
					class="menu-item"
					href="#"
					:class="{ active: currentSection === 'newPackages' }"
					@click.prevent="currentSection = 'newPackages'"
				>
					<span class="material-symbols-outlined">add_shopping_cart</span>
					{{ $t('Package.newPackages') }}
				</a>
			</div>
		</div>

		<!-- Loading Spinner -->
		<div v-if="loading" class="page-loading">
			<Loading />
		</div>

		<!-- Main Content -->
		<div v-else class="list-content">
			<component :is="currentComponent" />
		</div>
	</div>
</template>

<script>
import Loading from '@/components/user/layout/LoadingComponent.vue'; 
import MyPackagesComponent from '@/components/user/viewComponent/package/MyPackagesComponent.vue'; 
import NewPackagesComponent from '@/components/user/viewComponent/package/NewPackagesComponent.vue'; 
import apiClient from '@/axios'; 

export default {
	name: 'PackageInformationComponent',
	components: {
		Loading,
		MyPackagesComponent,
		NewPackagesComponent
	},
	data() {
		return {
			loading: false, 
			currentSection: 'myPackages'
		};
	},
	computed: {
		currentComponent() {
			return this.currentSection === 'myPackages' ? 'MyPackagesComponent' : 'NewPackagesComponent';
		}
	},
};

</script>

<style scoped>
.active {
	background-color: var(--logo-color);
	color: var(--text-white);
}

.menu-item {
	display: flex;
	align-items: center;
	text-decoration: none;
	color: inherit;
	padding: 10px;
	transition: background-color 0.3s;
}

.menu-item span {
	margin-right: 8px;
	font-size: 16px;
}

.material-symbols-outlined .active {
	color: var(--text-white);
}

.strip .right-strip {
	display: flex;
	align-items: center;
}

.right-strip a {
	display: flex;
	align-items: center;
	color: var(--text-white);
	text-decoration: none;
}

.right-strip a .material-icons-outlined {
	margin-right: 5px;
}

.page-loading {
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100vh;
}
</style>
